module.exports = __webpack_public_path__ + "img/PT.72242535.png";